import type { ModalFooterProps } from './types';

import styled from 'styled-components';

export const StyledFooter = styled.footer`
  padding: 0 26px;
  > div {
    padding: 12px 0 26px;
    border-top: 1px solid ${({ theme }) => theme.mantineColors.gray[4]};
    text-align: right;
  }
`;

/**
 * @deprecated
 */
const ModalFooter = ({ className, children }: ModalFooterProps) => {
  return (
    <StyledFooter className={className}>
      <div>{children}</div>
    </StyledFooter>
  );
};

export default ModalFooter;
